var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSchool(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 34,
    viewBox: "0 0 41 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.194 33.1998L7.36068 26.2332V15.2332L0.0273438 11.1998L20.194 0.199829L40.3607 11.1998V25.8665H36.694V13.2165L33.0273 15.2332V26.2332L20.194 33.1998ZM20.194 17.9832L32.7523 11.1998L20.194 4.4165L7.63568 11.1998L20.194 17.9832ZM20.194 29.029L29.3607 24.079V17.1582L20.194 22.1998L11.0273 17.1582V24.079L20.194 29.029Z",
    fill: "#0539BE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchool);
export default __webpack_public_path__ + "static/media/school.697374a509408ec0ac2f679c76d65265.svg";
export { ForwardRef as ReactComponent };